@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'third party assurance request'"
        [moduleType]="moduleType"
        [idProp]="'id'"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [DateProperties]="dateProps"
        (onDblClick)="openDetail($event)"
    >
    </cerrix-workspace>
}
